import 'core-js/fn/array/find';
import 'core-js/fn/string/starts-with';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import App from './App';
import { unregister } from './registerServiceWorker';
import { history, store } from './store';
import { ThemeProvider } from './styled-components';
import theme from './theme';

ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <ConnectedRouter history={history}>
                <Switch>
                    <Route path="/" component={App} />
                </Switch>
            </ConnectedRouter>
        </ThemeProvider>
    </Provider>,
    document.getElementById('root') as HTMLElement
);
unregister();



// WEBPACK FOOTER //
// ./src/index.tsx